import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/data';

const footerLinks = [
  {
    title: '游戏分类',
    links: [
      { label: '体育竞技', path: '/category/sports' },
      { label: '真人娱乐', path: '/category/live-casino' },
      { label: '电子游艺', path: '/category/slots' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '优惠活动', path: '/category/promotions' },
      { label: '常见问题', path: '/#faq' },
      { label: '存取款指南', path: '/article/payment-guide' },
      { label: '责任游戏', path: '/article/responsible-gaming' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '新会员指南', path: '/article/welcome-bonus-2026' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <Link to="/" className="inline-block mb-4">
                <span
                  className="text-xl md:text-2xl font-bold tracking-wide"
                  style={{ fontFamily: "var(--font-heading)" }}
                >
                  <span className="text-primary-500">必赢</span>
                  <span className="text-white">亚洲</span>
                </span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed mt-3">
                必赢亚洲是亚洲顶级娱乐游戏平台，提供体育竞技、真人娱乐、电子游艺等多元玩法。官方正版授权，安全存取款，极速到账。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-white mb-4 tracking-wide">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {siteInfo.year} {siteInfo.name} 版权所有 | 保留一切权利
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <span>客服邮箱：{siteInfo.email}</span>
              <span className="hidden sm:inline">|</span>
              <span>客服热线：{siteInfo.phone}</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}